export default __webpack_public_path__ + "static/media/T-box-slider3.381f140a.jpg";